export default __webpack_public_path__ + "static/media/instagram.2b9c549f.svg";